export { WhyHireOnVistaprint } from './WhyHireOnVistaprint';
